// Coach Status Constants
export const COACH_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  ONBOARDING: 'Onboarding',
} as const;

export const COACH_STATUS_OPTIONS = Object.values(COACH_STATUS);

// Specializations
export const SPECIALIZATIONS = {
  WEIGHT_LOSS: 'Weight Loss',
  MUSCLE_BUILDING: 'Muscle Building',
  STRENGTH_TRAINING: 'Strength Training',
  CARDIO_ENDURANCE: 'Cardio Endurance',
  SPORTS_PERFORMANCE: 'Sports Performance',
  REHABILITATION: 'Rehabilitation',
  NUTRITION: 'Nutrition Coaching',
  BODYBUILDING: 'Bodybuilding',
  POWERLIFTING: 'Powerlifting',
  OLYMPIC_LIFTING: 'Olympic Lifting',
  FUNCTIONAL_FITNESS: 'Functional Fitness',
  SENIOR_FITNESS: 'Senior Fitness',
  YOUTH_FITNESS: 'Youth Fitness',
  PRENATAL_FITNESS: 'Prenatal Fitness',
  CORRECTIVE_EXERCISE: 'Corrective Exercise',
} as const;

// Certifications
export const CERTIFICATIONS = {
  NASM_CPT: 'NASM-CPT',
  ACSM_CPT: 'ACSM-CPT',
  ACE_CPT: 'ACE-CPT',
  NSCA_CSCS: 'NSCA-CSCS',
  ISSA_CPT: 'ISSA-CPT',
  PRECISION_NUTRITION: 'Precision Nutrition',
  FMS: 'Functional Movement Screen',
  NASM_CES: 'NASM-CES',
  NASM_PES: 'NASM-PES',
  YOUTH_FITNESS: 'Youth Fitness Specialist',
  SENIOR_FITNESS: 'Senior Fitness Specialist',
  PRENATAL_FITNESS: 'Prenatal Exercise Specialist',
} as const;

// Performance Metrics
export const PERFORMANCE_METRICS = {
  CLIENT_SATISFACTION: 'Client Satisfaction',
  RETENTION_RATE: 'Retention Rate',
  REVENUE_GENERATED: 'Revenue Generated',
  SESSIONS_COMPLETED: 'Sessions Completed',
  RESPONSE_TIME: 'Response Time',
  GOAL_ACHIEVEMENT: 'Goal Achievement Rate',
  NEW_CLIENTS: 'New Clients',
  CLIENT_RETENTION: 'Client Retention',
} as const;

// Onboarding Steps
export const ONBOARDING_STEPS = [
  {
    key: 'contractSigned',
    title: 'Contract Signed',
    description: 'Employment contract completed and signed',
    required: true,
  },
  {
    key: 'accountRegistered',
    title: 'Account Registered',
    description: 'System account created and verified',
    required: true,
  },
  {
    key: 'trainerizeAdded',
    title: 'Trainerize Setup',
    description: 'Trainerize platform access configured',
    required: true,
  },
  {
    key: 'courseComplete',
    title: 'Training Course',
    description: 'Company training course completed',
    required: true,
  },
  {
    key: 'clientsAssigned',
    title: 'Clients Assigned',
    description: 'Initial client assignments made',
    required: false,
  },
] as const;

// Table Configuration
export const TABLE_PAGE_SIZES = [10, 25, 50, 100];
export const DEFAULT_PAGE_SIZE = 25;

// Rating Ranges
export const RATING_RANGES = {
  EXCELLENT: { min: 4.5, max: 5.0, color: '#52c41a' },
  GOOD: { min: 3.5, max: 4.4, color: '#1890ff' },
  AVERAGE: { min: 2.5, max: 3.4, color: '#faad14' },
  POOR: { min: 1.0, max: 2.4, color: '#f5222d' },
} as const;

// Performance Trends
export const PERFORMANCE_TRENDS = {
  UP: 'up',
  DOWN: 'down',
  STABLE: 'stable',
} as const;

// Chart Colors
export const CHART_COLORS = [
  '#1890ff',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#722ed1',
  '#fa8c16',
  '#13c2c2',
  '#eb2f96',
];

// Time Ranges
export const TIME_RANGES = {
  LAST_WEEK: 'Last Week',
  LAST_MONTH: 'Last Month',
  LAST_3_MONTHS: 'Last 3 Months',
  LAST_6_MONTHS: 'Last 6 Months',
  LAST_YEAR: 'Last Year',
  CUSTOM: 'Custom Range',
} as const;

// Search and Filter Configuration
export const SEARCH_DEBOUNCE_MS = 300;
export const AUTO_SAVE_DELAY_MS = 2000;

// Form Validation Rules
export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[\+]?[1-9][\d]{0,15}$/,
  NAME: /^[a-zA-Z\s]{2,50}$/,
  SALARY: { min: 0, max: 200000 },
  RATING: { min: 0, max: 5 },
} as const; 